import { href, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';
import './EmailConfirmation.css';
import { Header } from '../../components/header/Header';
import { MobileFooter } from '../../components/mobileFooter/MobileFooter';

const FaCheckCircleIcon = FaCheckCircle as React.FC<React.SVGProps<SVGSVGElement>>;

export const EmailConfirmation = () => {
	const navigate = useNavigate();

	return (
		<div>
			<Header style={{ backgroundColor: '#ffffff' }} />
			<div className='email-confirmation-page'>
				<section className='confirmation-section'>
					<motion.div
						initial={{ opacity: 0, scale: 0.9 }}
						animate={{ opacity: 1, scale: 1 }}
						transition={{ duration: 0.5, ease: 'easeOut' }}
						className='confirmation-card'
					>
						<motion.div
							initial={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{ delay: 0.3, duration: 0.5, type: 'spring' }}
							className='success-icon'
						>
							<FaCheckCircleIcon />
						</motion.div>
						<h2>E-Mail erfolgreich bestätigt! 🎉</h2>
						<p className='confirmation-text'>
							Deine E-Mail-Adresse wurde erfolgreich verifiziert. Du kannst dich jetzt
							in der Erledix App einloggen und direkt loslegen!
						</p>
						<button
							className='confirmation-button'
							onClick={() => window.location.href = 'erledix://login'}
						>
							Zur Erledix App
						</button>
					</motion.div>
				</section>
			</div>
			<MobileFooter />
		</div>
	);
};
